/*
 * Project: forca
 * File Created: Thursday, 7th October 2021 7:48:29 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import { exportPDF, drawDOM, DrawOptions } from '@progress/kendo-drawing';
import { defineFont } from '@progress/kendo-drawing/pdf';

import { setIsPDF } from '@Store/default.store';


class DocService {
	createPdf = (_options?: DrawOptions) => {
		defineFont({
			// PKA
			'source sans pro'                  : '/Static/react/components/PdfContainer/fonts/SourceSansPro-Regular.ttf',
			'source sans pro|bold'             : '/Static/react/components/PdfContainer/fonts/SourceSansPro-Bold.ttf',
			'source sans pro|italic'           : '/Static/react/components/PdfContainer/fonts/SourceSansPro-Italic.ttf',
			'source sans pro|bold|italic'      : '/Static/react/components/PdfContainer/fonts/SourceSansPro-BoldItalic.ttf',

			// LP
			'roboto'                  : '/Static/react/components/PdfContainer/fonts/Lato-Regular.ttf',
			'roboto|bold'             : '/Static/react/components/PdfContainer/fonts/Lato-Bold.ttf',
			'roboto|italic'           : '/Static/react/components/PdfContainer/fonts/Lato-Italic.ttf',
			'roboto|bold|italic'      : '/Static/react/components/PdfContainer/fonts/Lato-BoldItalic.ttf',

			// PBU
			'lato'                  : '/Static/react/components/PdfContainer/fonts/Roboto-Regular.ttf',
			'lato|bold'             : '/Static/react/components/PdfContainer/fonts/Roboto-Bold.ttf',
			'lato|italic'           : '/Static/react/components/PdfContainer/fonts/Roboto-Italic.ttf',
			'lato|bold|italic'      : '/Static/react/components/PdfContainer/fonts/Roboto-BoldItalic.ttf'
		});

		const apiUrl = document.querySelector('.pdf-body').getAttribute('data-api-url') as string;
		const documentName = document.querySelector('.pdf-body').getAttribute('data-document-name') as string;
		const gridElement = document.querySelector('.pdf-body') as any;
		const pdfOptions = Object.assign({
			forcePageBreak: '.page-break',
			keepTogether: '.prevent-break',
			paperSize: 'A4',
			margin: {
				left: '1cm',
				right: '1cm',
				top: '0.5cm'
			}, scale: 0.7
		}, _options || {});

		drawDOM(gridElement, pdfOptions)
			.then((group) => {
				return exportPDF(group);
			})
			.then((dataUri) => {
				const data = { base64: dataUri.split(';base64,')[1] };
				Doc.sendToServer(JSON.stringify(data), apiUrl, documentName);
			});
	};

	async sendToServer(data: any, apiUrl: string, documentName: string) {
		const response = await fetch(apiUrl, {
			method: 'POST',
			cache: 'no-cache',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				HtmlTekst: data,
				DokumentNavn: documentName
			})
		});
		const jsonData = await response.json();

		if (!jsonData) {
			console.error('Der er sket en fejl ved dannelse af dokument');
		}

		setIsPDF(false);
	}
}

const Doc = new DocService();
export default Doc;